import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback } from 'recoil'

import { Flex, LINK_VARIANT_DEFAULT, Link } from 'mailup-web-components'

import IconPlus from 'Components/icons/IconPlus'

import { panelAddRecipientOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/addRecipient'

const ActionAddRecipient: FC = () => {
  const intl = useIntl()

  const handleClick = useRecoilCallback(panelAddRecipientOpenCallback, [])

  return (
    <Link
      variant={LINK_VARIANT_DEFAULT}
      data-mu-test="recipients-add-recipient"
      onClick={handleClick}
    >
      <Flex alignItems="center" gap="8px">
        <IconPlus width="15" height="16" />

        <span>
          {intl.formatMessage({
            id: 'Load.RecipientsList.ActionAddRecipient',
          })}
        </span>
      </Flex>
    </Link>
  )
}

export default ActionAddRecipient
